(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqDetailController', LanguageIbqDetailController);

    LanguageIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Language'];

    function LanguageIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:languageUpdate', function(event, result) {
            vm.language = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
